// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"Tabs_tabsWrapper__oN4g9","tabs":"Tabs_tabs__EinYC","tabItem":"Tabs_tabItem__+lEwZ","tabItem_current":"Tabs_tabItem_current__lskVd","sticky":"Tabs_sticky__z2uhB"};